// extracted by mini-css-extract-plugin
module.exports = {"column":"resume-module--column--95SIj","title":"resume-module--title--1kf99","link":"resume-module--link--HLNml","container":"resume-module--container--3-JWl"};